var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_49_136)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.439484 0.439452C0.721374 0.158218 1.10331 0.000276566 1.5015 0.000276566C1.89969 0.000276566 2.28162 0.158218 2.56351 0.439452L4.50443 2.37964L6.44022 0.439452C6.7222 0.158396 7.1041 0.000578491 7.50223 0.000578491C7.90036 0.000578491 8.28226 0.158396 8.56424 0.439452C8.84548 0.721343 9.00342 1.10327 9.00342 1.50146C9.00342 1.89965 8.84548 2.28159 8.56424 2.56348L6.62186 4.5L8.56204 6.44019C8.8431 6.72217 9.00092 7.10407 9.00092 7.5022C9.00092 7.90033 8.8431 8.28222 8.56204 8.56421C8.28006 8.84526 7.89816 9.00308 7.50003 9.00308C7.1019 9.00308 6.72 8.84526 6.43802 8.56421L4.50003 6.62183L2.56351 8.56201C2.28152 8.84307 1.89963 9.00089 1.5015 9.00089C1.10337 9.00089 0.721469 8.84307 0.439484 8.56201C0.158428 8.28003 0.000610352 7.89813 0.000610352 7.5C0.000610352 7.10187 0.158428 6.71997 0.439484 6.43799L2.37821 4.5L0.439484 2.55908C0.159589 2.27737 0.00249607 1.89638 0.00249607 1.49927C0.00249607 1.10215 0.159589 0.72116 0.439484 0.439452Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_49_136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.9922f479df2b5b5bd488999da8c92009.svg";
export { ForwardRef as ReactComponent };